export const InitialAccordionActiveItems = [
  {
    indexOfInitiallyActive: 0,
    displayCompCoveredForDetails: true,
    isExpandedOnDesktop: true,
    isExpandedOnMobile: true,
  },
  {
    indexOfInitiallyActive: 0,
    displayKeyDifferences: true,
    isExpandedOnDesktop: true,
    isExpandedOnMobile: false,
  },
  {
    indexOfInitiallyActive: 1,
    displayHassleFreeClaims: true,
    isExpandedOnDesktop: true,
    isExpandedOnMobile: false,
  },
];

export const getIntialAccordionActiveItems = (
  displayCompCoveredForDetails: boolean,
  displayKeyDifferences: boolean,
  displayHassleFreeClaims: boolean,
  isDesktopView: boolean
) => {
  const initialAccordionActiveItems = InitialAccordionActiveItems.filter(
    (item) =>
      ((item.displayCompCoveredForDetails && displayCompCoveredForDetails) ||
        (item.displayKeyDifferences && displayKeyDifferences) ||
        (item.displayHassleFreeClaims && displayHassleFreeClaims)) &&
      ((item.isExpandedOnDesktop && isDesktopView) ||
        (item.isExpandedOnMobile && !isDesktopView))
  );

  return initialAccordionActiveItems.map((item) => item.indexOfInitiallyActive);
};
